import { FC } from 'react';

import { Box, Heading } from '@chakra-ui/react';
import {
  Card,
  TeamMember,
  TopTeamMember,
  PaginationList,
} from '../../../components';

import { TeamMemberProps } from '../../../utils';

/**
 * @prop teamMembers an array of TeamMember
 */
export interface TeamMembersProps {
  teamMembers: TeamMemberProps[];
}

export const TeamMembers: FC<TeamMembersProps> = (props) => {
  const { teamMembers } = props;

  if (teamMembers.length === 0) {
    return null;
  }

  const topTeamMember: TeamMemberProps = teamMembers[0];
  const otherTeamMembers: TeamMemberProps[] = teamMembers.slice(1);

  return (
    <Card>
      <Heading size="md" color="brand.primary.swatch1" mb="1rem">
        Team Members
      </Heading>
      <TopTeamMember {...topTeamMember} />
      <Box mb="1rem" />
      <PaginationList listItems={otherTeamMembers}>
        <TeamMember />
      </PaginationList>
    </Card>
  );
};
